/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { SelectableResourceService } from '@well/common-libs/selectable-resource-management/util';
import { ETransportConfirmationTypeVoModel } from '@well/delivery-libs/etransport/domain-model';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '@irian-ro/util-environment';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ETransportConfirmationTypeSelectableResourceService extends SelectableResourceService<ETransportConfirmationTypeVoModel> {
  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      `${environmentService.getEnvironmentProperty('eTransportConfirmationTypeUrl')}/resource-list`,
      ETransportConfirmationTypeVoModel
    );
  }
}
